// this is an autogenerated file from App/Account/NewPatient/Content/similarLeadsQuery.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_NewPatient_Content(
  $first_name: String!
  $last_name: String!
  $birth_date: String!
) {
  leads_leads_aggregate(
    where: {
      first_name: { _ilike: $first_name }
      last_name: { _ilike: $last_name }
      birth_date: { _ilike: $birth_date }
      patient_id: { _is_null: true }
    }
  ) {
    aggregate {
      count
    }
  }
}

`